const initState = {
  requests: [],
  requestsLastDocument: null,
  requestsHasMore: true,
};

const instituteRequestsReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_ALL_REQUESTS":
      return {
        ...state,
        requests: action.payload.data,
        requestsLastDocument: action.payload.lastDocument,
        requestsHasMore: action.payload.hasMore,
      };
    case "MORE_GET_ALL_REQUESTS":
      return {
        ...state,
        requests: [...state.requests, ...action.payload.data],
        requestsLastDocument: action.payload.lastDocument,
        requestsHasMore: action.payload.hasMore,
      };
    default:
      return {
        ...state,
      };
  }
};
export default instituteRequestsReducer;
